import React from 'react';
import './SunStudyTimeline.scss';
import TimelineDot from '@mui/lab/TimelineDot';
import TimelineConnector from '@mui/lab/TimelineConnector';
import { FileClientT, FileItemInCollectionT } from 'bovaljaren-models';
import { PlayArrow } from '@material-ui/icons';
import { IconButton } from '@material-ui/core';

type ItemProps = {
    onClick: () => void;
    label: string;
    selected?: boolean;
    last: boolean;
    index: number;
}

const SunStudyTimeItem: React.FC<ItemProps> = ({ onClick, label, selected = false, last, index }) =>
    <div className='bv-sunstudy-timeline-item' onClick={onClick}>
        <div className='bv-sunstudy-timeline-item-top'>
            {index !== 0 ? <TimelineConnector className='bv-sunstudy-timeline-item-connector' /> : <div className='bv-sunstudy-timeline-item-filler'/>}
            <TimelineDot className='bv-sunstudy-timeline-item-dot' variant={selected ? 'filled' : 'outlined'}/>
            {!last ? <TimelineConnector className='bv-sunstudy-timeline-item-connector' /> : <div className='bv-sunstudy-timeline-item-filler'/> }
        </div>
        <div className='bv-sunstudy-timeline-item-bottom'>{label}</div>
    </div>;

export type SunStudyTimelineProps = {
    items: FileItemInCollectionT[];
    onClick: (item: FileItemInCollectionT) => void;
    selectedItem: FileItemInCollectionT;
    play: () => void;
}

export const timeFilenameToTimeString = (value: string) => {
    const text = value.split('.')[0];
    const first = text.slice(0, 2);
    const last = text.slice(-2);

    return `${first}:${last}`;
};

const SunstudyTimeline: React.FC<SunStudyTimelineProps> = ({ items, onClick, selectedItem, play }) => {
    return (
        <div className={'bv-sunstudy-timeline-wrapper'}>
            <div className='bv-sunstudy-timeline'>
                {items.map((i, index) => <SunStudyTimeItem key={i.id} index={index} selected={selectedItem.id === i.id} onClick={(): void => onClick(i)} last={index === items.length - 1}label={timeFilenameToTimeString(i.filename)} />)}
            </div>
            <div className='bv-sunstudy-play-wrapper'><IconButton className={'bv-sunstudy-timeline-play'} onClick={play}><PlayArrow /></IconButton></div>
        </div>
    );
};

export default SunstudyTimeline;